/*
 * Forge Maestro
 * (c) Honeywell
 */

import { __rest } from '../../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef, Children } from 'react';
import { isEmpty } from '../../utils/common/is-empty.js';
import { isNotNil } from '../../utils/common/is-nil.js';
import '../../utils/responsive/breakpoint/breakpoint-boundaries.const.js';
import '../../utils/responsive/breakpoint/breakpoint.enum.js';
import styles from './Button.module.scss.js';
import { ButtonIcon } from './ButtonIcon.js';

const Button = forwardRef((props, ref) => {
    const { children, className = '', tabIndex, type = 'button', disabled = false, icon, iconPosition = 'left', size = 'regular', variant = 'primary', onClick, label } = props, rest = __rest(props, ["children", "className", "tabIndex", "type", "disabled", "icon", "iconPosition", "size", "variant", "onClick", "label"]);
    const iconOnly = Children.count(children) === 0 ||
        isEmpty(Children.toArray(children).filter(Boolean));
    if (iconOnly && isEmpty(label)) {
        throw new Error('Label must be added to buttons with only icon');
    }
    return (jsxs("button", Object.assign({ type: type, ref: ref, tabIndex: tabIndex, disabled: disabled, className: classNames(styles.button, styles[variant], styles[size], {
            [styles['icon-only']]: iconOnly,
            [styles[`icon-${iconPosition}`]]: isNotNil(icon) && !iconOnly,
        }, className), onClick: onClick, "aria-label": iconOnly ? label : undefined }, rest, { children: [jsx(ButtonIcon, { icon: icon, position: iconOnly ? undefined : iconPosition, size: size, iconOnly: iconOnly }), children ? (jsx("span", Object.assign({ className: styles.children }, { children: children }))) : undefined] })));
});

export { Button };
//# sourceMappingURL=Button.js.map
